import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Login } from 'web/components/common/modal';
import { initModal, pushModal } from 'shared/actions/modal.action';
import { pushToastApp } from 'shared/actions/toast.action';

import {
  postAuthTokenRequest,
  startLoginData,
  finishLoginData,
  setLoginData,
  setLoginError,
} from 'shared/actions/auth.action';

@connect(
  (state, props) => ({
    auth: state.shared.auth,
    modal: state.shared.modal,
  }),
  {
    initModal,
    pushModal,
    postAuthTokenRequest,
    startLoginData,
    finishLoginData,
    setLoginData,
    setLoginError,
    pushToastApp,
  },
)
class LoginContainer extends Component {
  componentDidMount() {
    this.props.startLoginData();
    if (this.props.modal.data && this.props.modal.data.username) {
      this.props.setLoginData({
        username: this.props.modal.data.username,
      });
    }
  }

  componentWillUnmount() {
    this.props.finishLoginData();
  }

  state = {
    username: '',
    password: '',
  };

  handleChange = e => {
    const key = e.target.name;
    const value = e.target.value;
    this.props.setLoginData({
      [key]: value,
    });

    let error = {};
    // console.log('handleChange', { key, value });
    if (key === 'username') {
      error = this.verificationUsername(value);
    } else if (key === 'password') {
      error = this.verificationPassword(value);
    }

    if (Object.keys(error)) {
      this.props.setLoginError(error);
    }
  };

  verificationPassword = (password = '') => {
    let error = {};
    // console.log('verificationPassword', password.length);
    if (password.length < 8) {
      error.status = true;
      error.type = 'password';
      error.desc = '비밀번호는 최소 8자 입니다.';
    } else {
      error.status = false;
      error.type = '';
      error.desc = '';
    }

    return error;
  };
  verificationUsername = username => {
    const regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
    // console.log('verificationUsername', username.match(regExp));

    let error = {};
    if (username.match(regExp) === null) {
      error.status = true;
      error.type = 'username';
      error.desc = '올바른 이메일을 입력해주세요.';
    } else {
      error.status = false;
      error.type = '';
      error.desc = '';
    }
    return error;
  };

  handleSubmit = e => {
    e.preventDefault();
    console.log('handleSubmit!!!!!!');
    const { username, password } = this.props.auth.login;

    if (!username.trim() || !password.trim())
      return alert('username과 password를 정확히 입력해 주세요.');

    let data = { username, password };
    this.props.postAuthTokenRequest(data, () => {
      // console.log('LOGIN - SUCCESS');
      this.props.initModal();
      const splitPath = window.location.pathname.split('/');
      const isStudy = splitPath[1].toLowerCase() === 'study';
      const isPlayer = splitPath[1].toLowerCase() === 'player';
      if ((isStudy && splitPath[3].toLowerCase() !== 'detail') || isPlayer)
        window.location.reload();
    });
  };

  render() {
    const { login = {} } = this.props.auth;
    const { username, password, error } = login;
    return (
      <Login
        username={username}
        password={password}
        error={error}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        handlePopup={this.props.popupHandler}
      />
    );
  }
}

export default LoginContainer;
